import { z } from 'zod';
/**
 * Tayyor varaq turlari. `ROLL_100x80` — Gainscha GS-2406T ga qo'yilgan
 * rulon (100 × 80 mm). `ROLL_100x80_2` va `ROLL_105x80_2` — o'sha qog'oz,
 * lekin bitta yopishqoqda IKKITA etiketka: qog'oz ikki barobar tejaladi,
 * evaziga kesish chizig'i bo'ylab qaychilanadi. Ikki en ikki xil rulon
 * uchun — 105 mm eng keng tarqalgani, 100 mm eskiroq apparatlarda.
 * `CUSTOM` — o'zi kiritadigan o'lcham.
 *
 * `CUSTOM` ro'yxatda turishining sababi jismoniy: rulon etiketkasi har xil
 * o'lchamda sotiladi (40×30, 58×40, 100×50 …) va omborga qaysi biri kelgani
 * oldindan ma'lum emas. Qattiq ro'yxat bilan chegaralansa, boshqa rulon
 * kelgan kuni tizim ishlamay qoladi — printerda esa o'lcham bir millimetr
 * xato bo'lsa bosma etiketkadan siljib ketadi.
 */
export const LABEL_PRESET_CODES = [
    'ROLL_100x80',
    'ROLL_100x80_2',
    'ROLL_105x80_2',
    'ZEBRA_58x40',
    'A4_24',
    'A4_12',
    'CUSTOM',
];
export const labelPresetSchema = z.enum(LABEL_PRESET_CODES);
/**
 * Rulon etiketkasining o'lchami, MILLIMETRDA.
 *
 * Chegaralar printerning jismoniy imkoniyatidan: bosma kallak 4 dyuymgacha
 * (≈108 mm), lekin A4 gacha ruxsat berilgan — oddiy printerda ham bosiladi.
 * Pastki chegara shtrix-koddan: 20 mm dan tor etiketkaga Code128 sig'maydi
 * va skaner uni o'qiy olmaydi.
 */
export const labelSizeSchema = z.object({
    widthMm: z.number().min(20).max(210),
    heightMm: z.number().min(15).max(297),
    /**
     * Bitta yopishqoq qog'ozga nechta etiketka: 1 yoki 2.
     *
     * Ikkitasi qog'ozni ikki barobar tejaydi — qog'oz baland bo'lsa bitta
     * kodga shuncha joy baribir kerak emas. Evaziga kesish chizig'i bo'ylab
     * qaychilanadi.
     */
    perSheet: z.union([z.literal(1), z.literal(2)]).default(1),
});
/**
 * Bir so'rovda bosiladigan etiketka chegarasi (`2000` ta ≈ 85 varaq).
 *
 * Shartnomada turadi, chunki uni IKKI tomon ham biladi: backend so'rovni rad
 * etadi, frontend esa tugmani oldindan o'chirib qo'yadi va odam 3000 ta
 * etiketkani bosib chiqarishga urinib, xatoni faqat kutgandan keyin ko'rmaydi.
 */
export const MAX_LABELS_PER_REQUEST = 2000;
/**
 * Etiketka so'rovi.
 *
 * Yuqori chegara ataylab SXEMADA EMAS, xizmatda tekshiriladi: u yerda
 * foydalanuvchi tushunadigan aniq matn beriladi ("Bir marta ko'pi bilan 2000
 * ta etiketka bosiladi"), validatsiya xatosining umumiy matni emas.
 *
 * `size` esa aynan shu yerda majburlanadi: `CUSTOM` tanlanib o'lcham
 * yuborilmasa, server nimadir taxmin qilib bosmasligi kerak — noto'g'ri
 * o'lcham qog'ozni behuda sarflaydi.
 */
export const printCellLabelsSchema = z
    .object({
    cellIds: z.array(z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak')).min(1),
    preset: labelPresetSchema,
    size: labelSizeSchema.optional(),
})
    .refine((input) => input.preset !== 'CUSTOM' || input.size !== undefined, {
    message: 'Etiketka o\'lchamini kiriting',
    path: ['size'],
});
/**
 * Bitta partiyaga nechta nusxa bosiladi.
 *
 * Jimlikda BITTA va sabab jismoniy: 120 dona bolt omborga bitta qutida
 * keladi, etiketka esa qutiga yopishtiriladi — ya'ni "bitta joylashuv =
 * bitta etiketka". Nusxa soni mol bir necha qutiga bo'lingan holat uchun
 * qoladi: skladchi har qutiga bittadan yopishtiradi.
 *
 * Yuqori chegara 100: undan ko'pi bitta qutini emas, DONALAB belgilashni
 * anglatadi va u boshqa ish (boshqa etiketka, boshqa o'lcham).
 */
export const MAX_LABEL_COPIES = 100;
export const batchLabelItemSchema = z.object({
    batchId: z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak'),
    copies: z.number().int().min(1).max(MAX_LABEL_COPIES).default(1),
});
/**
 * MAHSULOT ETIKETKASI — partiya bo'yicha, katak bo'yicha EMAS.
 *
 * Farq ataylab va u butun oqimni belgilaydi: etiketka qutiga yopishadi va
 * mahsulot bilan birga yuradi. Mol boshqa katakka ko'chirilsa etiketka
 * yolg'onga aylanmaydi — katakning o'z etiketkasi bor va berish paytida
 * ikkovi solishtiriladi ("to'g'ri javonga bordim" + "to'g'ri molni oldim").
 *
 * `items` — juftliklar ro'yxati, oddiy identifikatorlar emas: nusxa soni
 * har partiyaga ALOHIDA. Bitta kirimda bir mahsulot bitta qutida, boshqasi
 * o'ntada kelishi oddiy hol.
 */
export const printBatchLabelsSchema = z
    .object({
    items: z.array(batchLabelItemSchema).min(1).max(200),
    preset: labelPresetSchema,
    size: labelSizeSchema.optional(),
})
    .refine((input) => input.preset !== 'CUSTOM' || input.size !== undefined, {
    message: 'Etiketka o\'lchamini kiriting',
    path: ['size'],
});
/**
 * A4 varaqlarida chekka NOLGA teng, va bu ataylab: tayyor o'yilgan
 * etiketka qog'ozi aynan shunday yasaladi — 3 × 70 = 210 mm, ya'ni yon
 * chekka umuman qolmaydi. 5 mm chekka qo'yilsa bir ustun yo'qolib,
 * `A4_24` dan 24 ta emas, 14 ta etiketka chiqadi va bosma o'yiq
 * joylardan siljib ketadi.
 *
 * Yarimlangan rulonlarda sahifa O'SHA-O'SHA qoladi, etiketka esa yarmi
 * bo'ladi: rulon printeri har bosmada qog'ozni bir sahifa bo'yi suradi
 * va kesish joyida to'xtaydi — sahifani kichraytirsak, qog'oz noto'g'ri
 * joyda uzilardi.
 */
/**
 * KESISH YO'LAGI (mm) — ikkiga bo'lingan qog'ozdagi oq oraliq.
 *
 * Nolga teng bo'lsa qaychi matnning ustidan yurardi: pastki etiketkaning
 * qora sarlavha bandi yuqoridagining eng pastki qatoriga tegib turardi va
 * bir millimetr qiyshiq kesilgan qog'oz ikkala etiketkani ham buzardi.
 * Bu yo'lak — QOG'OZ EMAS, chidam: uning ichiga kesish chizig'i tushadi.
 */
export const LABEL_CUT_GUTTER_MM = 1.2;
export const LABEL_SHEETS = {
    ROLL_100x80: { pageW: 100, pageH: 80, labelW: 100, labelH: 80, marginMm: 0, gapMm: 0 },
    ROLL_100x80_2: {
        pageW: 100,
        pageH: 80,
        labelW: 100,
        labelH: (80 - LABEL_CUT_GUTTER_MM) / 2,
        marginMm: 0,
        gapMm: LABEL_CUT_GUTTER_MM,
    },
    ROLL_105x80_2: {
        pageW: 105,
        pageH: 80,
        labelW: 105,
        labelH: (80 - LABEL_CUT_GUTTER_MM) / 2,
        marginMm: 0,
        gapMm: LABEL_CUT_GUTTER_MM,
    },
    A4_24: { pageW: 210, pageH: 297, labelW: 70, labelH: 36, marginMm: 0, gapMm: 0 },
    A4_12: { pageW: 210, pageH: 297, labelW: 100, labelH: 48, marginMm: 0, gapMm: 0 },
    ZEBRA_58x40: { pageW: 58, pageH: 40, labelW: 58, labelH: 40, marginMm: 0, gapMm: 0 },
};
/**
 * So'rovdan varaq geometriyasi.
 *
 * `CUSTOM` da sahifaning O'ZI bitta etiketka bo'ladi (`pageW = labelW`).
 * Shu sababli chekka ham, oraliq ham nol: bir millimetr chekka butun
 * bosmani etiketkadan siljitadi.
 */
export const labelSheetOf = (preset, size) => {
    if (preset !== 'CUSTOM')
        return LABEL_SHEETS[preset];
    if (size === undefined)
        throw new Error('Etiketka o\'lchamini kiriting');
    /* Ikkiga bo'linsa sahifa O'SHA-O'SHA qoladi: rulon printeri har bosmada
       qog'ozni bir sahifa bo'yi suradi. Etiketka esa yarmidan ham kichik —
       orada kesish yo'lagi turadi. */
    const gapMm = size.perSheet > 1 ? LABEL_CUT_GUTTER_MM : 0;
    return {
        pageW: size.widthMm,
        pageH: size.heightMm,
        labelW: size.widthMm,
        labelH: (size.heightMm - gapMm * (size.perSheet - 1)) / size.perSheet,
        marginMm: 0,
        gapMm,
    };
};
/**
 * Sahifaga nechta etiketka sig'adi.
 *
 * Formulada `+ gap`: oxirgi ustundan keyin oraliq kerak emas, shuning
 * uchun `n` ta etiketka `n*labelW + (n-1)*gap` joy egallaydi. Buni `n`
 * ga nisbatan yechish `floor((usable + gap) / (labelW + gap))` beradi.
 *
 * Sig'masa `0` qaytadi, xato ATILMAYDI: bu qatlam sof hisob va "sig'gani
 * yo'q" ham javob. Xato matnini chizuvchi beradi — u yerda nima
 * qilinayotgani ma'lum.
 */
export const labelSheetCounts = (sheet) => {
    const cols = Math.floor((sheet.pageW - 2 * sheet.marginMm + sheet.gapMm) / (sheet.labelW + sheet.gapMm));
    const rows = Math.floor((sheet.pageH - 2 * sheet.marginMm + sheet.gapMm) / (sheet.labelH + sheet.gapMm));
    if (cols < 1 || rows < 1)
        return { cols: 0, rows: 0, perSheet: 0 };
    return { cols, rows, perSheet: cols * rows };
};
/**
 * Shuncha etiketkaga nechta QOG'OZ ketadi — `null` bo'lsa hisoblab
 * bo'lmaydi (o'lcham to'liq emas yoki etiketka sahifaga sig'maydi).
 *
 * `null` ni «0» bilan almashtirish mumkin emas: nol "qog'oz ketmaydi"
 * degani bo'lib o'qilardi, aslida esa "bilmayman" deyilmoqda.
 */
export const labelSheetsNeeded = (count, preset, size) => {
    if (count <= 0)
        return 0;
    let sheet;
    try {
        sheet = labelSheetOf(preset, size);
    }
    catch {
        return null;
    }
    const { perSheet } = labelSheetCounts(sheet);
    return perSheet === 0 ? null : Math.ceil(count / perSheet);
};
//# sourceMappingURL=label.schema.js.map